import React, { useEffect, useState } from "react";
import { IRouteAccessModel } from "../interface/common";
import {
  createNewRouteAccessModel,
  deleteAclGuardStatusFromStorage,
  getAccessLevel,
} from "../utils/Helper";
import ShortUniqueId from "short-unique-id";
export interface IAclContext extends IRouteAccessModel {
  isOn: boolean;
  name: string;
}
export const AclContext = React.createContext<IAclContext>({
  isOn: false,
  name: "",
  ...createNewRouteAccessModel(),
});

export interface IAclGuardOverrideProps {
  path?: string;
  create?: boolean;
  update?: boolean;
  read?: boolean;
  delete?: boolean;
  softDelete?: boolean;
  approve?: boolean;
}

interface IAclGuardProps {
  status?: "ON" | "OFF"; // default value
  override?: IAclGuardOverrideProps;
  children: React.ReactNode;
}

const AclGuard = React.forwardRef((props: IAclGuardProps, ref: any) => {
  const { children, override, status } = props;
  const uid = new ShortUniqueId({ length: 5 });

  const [aclContext, setAclContext] = useState({
    isOn: false,
    name: "",
    ...createNewRouteAccessModel(),
  });

  const routeAccessModelObj = override
    ? {
        path: override?.path ?? "",
        create: !override?.read,
        update: !override?.read,
        read: !override?.read,
        delete: !override?.read,
        softDelete: !override?.read,
        approve: !override?.read,
      }
    : getAccessLevel();

  /**
   * executed once when component is mounted
   */
  useEffect(() => {
    setContext();
    // Un mounting the component
    return () => {
      // deleteAclGuardStatusFromStorage(aclContext.name);
    };
  }, []);

  /**
   * executed once when status & override value changes
   */
  useEffect(() => {
    setContext();
  }, [status, override]);

  /**
   * executed once when the state of the context changes
   */
  useEffect(() => {
    if (!aclContext.isOn) {
      deleteAclGuardStatusFromStorage(aclContext.name);
    }
  }, [aclContext]);

  //  set the context variable based on state based on the status
  const setContext = () => {
    // console.log("override====", override?.read, routeAccessModelObj.read);

    const aclContext1 = {
      ...routeAccessModelObj,
      read: override && override?.read ? routeAccessModelObj.read : getAccessLevel().read,
      create: override && override?.create ? routeAccessModelObj.create : getAccessLevel().create,
      update: override && override?.update ? routeAccessModelObj.update : getAccessLevel().update,
      delete: override && override?.delete ? routeAccessModelObj.delete : getAccessLevel().delete,
      softDelete:
        override && override?.softDelete
          ? routeAccessModelObj.softDelete
          : getAccessLevel().softDelete,
      approve:
        override && override?.approve ? routeAccessModelObj.approve : getAccessLevel().approve,
      name: aclContext.name ? aclContext.name : uid.rnd(),
      isOn: status !== "OFF", // boolean
    };
    // console.log("aclContext1====", aclContext1);
    setAclContext(aclContext1);
  };

  React.useImperativeHandle(ref, () => ({
    props,
    getStatus: () => aclContext,
  }));

  return <AclContext.Provider value={aclContext}>{children}</AclContext.Provider>;
});

export default AclGuard;
